import { BenefitDTOBenefitEnum, DocumentsDTO, TenantDTO } from 'probonio-shared-ui/api';
import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionInterface } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitMenuItemInterface } from '../../module/benefits/nav/BenefitMenuItem';
import { BenefitMetadataExtensionInterface } from './benefit-metadata.extension.interface';

export abstract class BenefitNavigationExtensionInterface extends ExtensionInterface {
  abstract getMenuItems({
    customBenefitId,
    tenant,
    documents,
  }: {
    customBenefitId?: string;
    tenant?: TenantDTO;
    documents?: DocumentsDTO;
  }): BenefitMenuItemInterface[];
}

const benefitNavigationCache = new Map<BenefitDTOBenefitEnum, BenefitNavigationExtensionInterface>();
/**
 * Retrieves the benefitNavigationExtension for a specific benefit type.
 * Uses caching to avoid redundant EXTENSIONS lookups.
 *
 * @param benefit - The benefit enum value (e.g., BenefitDTOBenefitEnum.Lunch)
 * @returns The matched benefitNavigationExtension, or undefined if none exist
 */
export function getBenefitNavigation(benefit: BenefitDTOBenefitEnum): BenefitNavigationExtensionInterface | undefined {
  if (benefitNavigationCache.has(benefit)) {
    return benefitNavigationCache.get(benefit);
  }

  const keyedBenefitMetadataExtensionProvider = EXTENSIONS.getKeyedProviders(BenefitMetadataExtensionInterface).find(
    ({ provider }) => provider.benefitId === benefit,
  );

  const benefitNavigationProvider = EXTENSIONS.getProviderByKey(
    keyedBenefitMetadataExtensionProvider?.key,
    BenefitNavigationExtensionInterface,
  );

  if (!benefitNavigationProvider) {
    return undefined;
  }

  benefitNavigationCache.set(benefit, benefitNavigationProvider);

  return benefitNavigationProvider;
}
